import { render } from "./FemalePercentageSingleValue.vue?vue&type=template&id=876a38c0&scoped=true"
import script from "./FemalePercentageSingleValue.vue?vue&type=script&lang=js"
export * from "./FemalePercentageSingleValue.vue?vue&type=script&lang=js"

import "./FemalePercentageSingleValue.vue?vue&type=style&index=0&id=876a38c0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/customer-interface-v3/customer-interface-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-876a38c0"]])

export default __exports__